/**
 * A única regra de filtro que as duas barras do painel compartilham
 * (spec-calendar.md §9, decisão 64): **escolher uma coordenação encolhe a lista
 * de ministérios**.
 *
 * Ela sobe para `shared/` porque oferecer os dez ministérios da igreja depois de
 * a pessoa ter dito "só Louvor e Adoração" produz o combo que devolve vazio — e
 * esse erro não é de uma tela, é do par de seletores. O resto das duas barras é
 * diferente de propósito: `/projetos` tem busca por título (que no calendário
 * não faz sentido — a grade é o índice) e não tem espaço (que ali é essencial).
 *
 * ⚠️ O parâmetro é uma **lista** desde a decisão 106: a folha de filtros do
 * calendário marca quantas coordenações quiser, e a barra de `/projetos`, que
 * escolhe uma só, passa `[id]`. Lista vazia e ausente significam a mesma coisa:
 * ninguém escolheu, então nada encolhe.
 */
export interface MinistryOption {
  id: string;
  name: string;
  coordination_id: string;
}

export function narrowMinistriesByCoordinations<T extends MinistryOption>(
  ministries: readonly T[],
  coordinationIds: readonly string[] | undefined,
): readonly T[] {
  if (!coordinationIds || coordinationIds.length === 0) return ministries;
  const chosen = new Set(coordinationIds);
  return ministries.filter((ministry) => chosen.has(ministry.coordination_id));
}
